(function(){

	var ativadorSombra = $('[data-sombra="true"]');

	var alvoClasse = $('body');

	var alvoClasseClassesToggle = alvoClasse.attr('data-toggle');

	ativadorSombra.on('click',function(){
		alvoClasse.addClass('sombra');
		desligar.fadeIn('500');
	});

	var desligar = $('[data-desligador="true"]');

	desligar.on('click',function(){
		alvoClasse.removeClass(alvoClasseClassesToggle);
		$(this).fadeOut('500');
	});

	var menuToggle = $('[data-menu-active="true"]');

	menuToggle.on('click',function(){
		alvoClasse.addClass('menu-active');
	});
	
})();